var script = {
  inject: ["getWorkbook"],
  props: {
    filename: {
      type: String,
      default: "my-workbook.xlsx",
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    disableWrapperClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    loaded: {
      immediate: true,
      handler(loaded) {
        if (loaded) {
          this.getWorkbook((wb) => {
            this._workbook = wb;
          });
        }
      },
    },
  },
  methods: {
    async load() {
      const { writeFile } = await import("xlsx");
      this._writeFile = writeFile;
      this.loaded = true;
    },
    download() {
      this._writeFile(this._workbook, this.filename, this.options);
    },
  },
  render(h) {
    if (this.$scopedSlots.default && this.loaded) {
      return h(
        "div",
        {
          on: {
            click: this.disableWrapperClick ? () => {} : this.download,
          },
        },
        [
          this.$scopedSlots.default({
            download: this.download,
          }),
        ]
      );
    }
    return null;
  },
};

function normalizeComponent(
  template,
  style,
  script,
  scopeId,
  isFunctionalTemplate,
  moduleIdentifier,
  /* server only */
  shadowMode,
  createInjector,
  createInjectorSSR,
  createInjectorShadow
) {
  if (typeof shadowMode !== "boolean") {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.

  var options = typeof script === "function" ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId

  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        //context = __VUE_SSR_CONTEXT__;
      } // inject component styles

      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference

      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called

    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode
      ? function () {
          style.call(
            this,
            createInjectorShadow(this.$root.$options.shadowRoot)
          );
        }
      : function (context) {
          style.call(this, createInjector(context));
        };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = undefined;
/* style inject */

/* style inject SSR */

var XlsxDownload = normalizeComponent_1(
  {},
  __vue_inject_styles__,
  __vue_script__,
  __vue_scope_id__,
  __vue_is_functional_template__,
  __vue_module_identifier__,
  undefined,
  undefined
);

export default XlsxDownload;
